<div
  animate.enter="animate-down"
  animate.leave="animate-up"
  class="bg-gray-700 w-full min-h-screen flex items-center justify-center"
>
  <div
    class="bg-white w-full h-screen rounded-xl flex flex-col items-center justify-center relative"
  >
    <img src="assets/images/emblem.png" class="w-20" alt="" />
    <span class="text-black text-xl font-bold mt-5 mb-2">{{
      "Reset Your Password?" | concat | translate
    }}</span>
    <p class="text-gray-dark text-center">
      {{
        "Your new password should be different from previous passwords"
          | concat
          | translate
      }}
    </p>
    <form
      (ngSubmit)="submitForm(form.value)"
      [formGroup]="form"
      class="w-full mt-3"
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ "New Password" | concat | translate }}</mat-label>
        <input
          [type]="showPassword ? 'password' : 'text'"
          matInput
          formControlName="password"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="showPassword = !showPassword"
          [attr.aria-label]="'Hide'"
          [attr.aria-pressed]="showPassword"
        >
          <mat-icon class="material-icons-outlined"
            >{{ showPassword ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
        <mat-error>
          @if(!form.get('password')?.valid && form.get('password')?.touched){

          }
          <span>
            {{ "Field is required" | concat | translate }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "Confirm Password" | concat | translate }}</mat-label>
        <input
          [type]="showPassword2 ? 'password' : 'text'"
          matInput
          formControlName="confirmPassword"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="showPassword2 = !showPassword2"
          [attr.aria-label]="'Hide'"
          [attr.aria-pressed]="showPassword2"
        >
          <mat-icon class="material-icons-outlined"
            >{{ showPassword2 ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
        <mat-error>
          @if(!form.get('confirmPassword')?.valid &&
          form.get('confirmPassword')?.touched){
          <span>
            {{ "Field is required" | concat | translate }}
          </span>
          }
        </mat-error>
      </mat-form-field>

      <div class="w-full mb-3">
        <button
          type="submit"
          [disabled]="!form.valid || loading"
          class="w-full"
          mat-raised-button
          color="primary"
        >
          {{ "Reset Password" | concat | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
